import Category from '../../Category'
import Loading from '../../Loading'

export default function SearchedResults({
  productsContentProps,
  searchResults,
  sorting,
  setOpen,
  setSelect,
}) {
  const {categories, productsLayout, layout, menuId, hidePrice, productCardDesign} =
    productsContentProps
  if (!categories) return <Loading />

  const category = {
    _id: 'search',
    name: 'Resultados',
    products: searchResults,
  }

  if (searchResults.length === 0) {
    return <div>No se encontraron resultados</div>
  }

  return (
    <Category
      productsLayout={productsLayout}
      layout={layout}
      category={category}
      menuId={menuId}
      hidePrice={hidePrice}
      select={select => {
        setSelect(select)
        setOpen(true)
      }}
      productCardDesign={productCardDesign}
      sorting={sorting}
    />
  )
}
